module.exports = __webpack_public_path__ + "img/ind.df93572c.svg";